import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Invoice from "./Invoice";
import { Order } from "./Order";
export class OrderInvoice {
  constructor() {
    _defineProperty(this, "Invoice", {
      fieldName: 'invoice',
      fieldTitle: 'Order',
      model: Invoice,
      content: null
    });
    _defineProperty(this, "Order", {
      fieldName: 'order',
      fieldTitle: 'Invoice',
      model: Order,
      content: null
    });
  }
  getInvoice() {
    return this.Invoice.content;
  }
  isIssuedForWarehouse() {
    let invoice = this.getInvoice();
    return invoice instanceof Invoice && invoice.isIssuedForWarehouse();
  }
  isSellersPaid() {
    let invoice = this.getInvoice();
    return invoice instanceof Invoice && invoice.isSellersPaid();
  }
}
export default OrderInvoice;